import { requestApiUser } from "../functions";
import { requestApiClient } from "../functions";

export const CategoriesQueriesUser = {
    create: async (data) => {
        const res = await requestApiUser('/products/categories', 'POST', data);
        return res;
    },

    findById: async (id) => {
        const res = await requestApiUser(`/products/categories/${id}`, 'GET');
        return res;
    },

    findAll: async () => {
        const res = await requestApiUser('/products/categories', 'GET');
        return res;
    },

    update: async (id, data) => {
        const res = await requestApiUser(`/categories/${id}`, 'PUT', data);
        return res;
    },

    delete: async (id) => {
        const res = await requestApiUser(`/products/categories/${id}`, 'DELETE');
        return res;
    },

    addCategoryToProduct: async (productId, categoryId) => {
        const res = await requestApiUser(`/products/categories/${categoryId}/products/${productId}`, 'POST');
        return res;
    },

    removeCategoryFromProduct: async (productId, categoryId) => {
        const res = await requestApiUser(`/products/categories/${categoryId}/products/${productId}`, 'DELETE');
        return res;
    },
}

export const CategoriesQueriesClient = {
    findAll: async () => {
        const res = await requestApiClient('/products/categories', 'GET');
        return res;
    },

    findById: async (id) => {
        const res = await requestApiClient(`/products/categories/${id}`, 'GET');
        return res;
    },

    create: async (data) => {
        const res = await requestApiClient('/products/categories', 'POST', data);
        return res;
    },
    
    update: async (id, data) => {
        const res = await requestApiClient(`/products/categories/${id}`, 'PUT', data);
        return res;
    },

    delete: async (id) => {
        const res = await requestApiClient(`/products/categories/${id}`, 'DELETE');
        return res;
    }
}